"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import ComparisonComponent from "./components/comparison";
import OnDemandCards from "./components/chooseOnDemand";
import ContactCta from "./components/contactCta";
import FeaturesComp from "./components/features";

const ManagedUnmanagedCoManagedPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout showContactForm>
        <PrivateCloudTabs />
        <Intro />
        <FeaturesComp />
        <ContactCta />
        <ComparisonComponent />
        <OnDemandCards />\
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default ManagedUnmanagedCoManagedPage;
